import React from 'react';
import HeroImg from './aboutp.png'

const StorySection = () => {
  return (
    <div className="relative w-full h-[600px] bg-neutral-900 text-white overflow-hidden flex items-center">
      {/* Background/Focal Image on right side */}
      <div className="absolute inset-0 md:left-1/3 w-full md:w-2/3 h-full">
        <img 
          src={HeroImg} 
          alt="Traditional Saree Silhouette" 
          className="w-full h-full object-cover opacity-80 md:opacity-100"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-950 via-neutral-900/50 to-transparent"></div>
      </div>

      {/* Text Content Overlay */}
      <div className="relative z-10 max-w-xl px-8 md:px-16 space-y-6">
        <h2 className="font-serif text-4xl tracking-wide border-b border-amber-600/30 pb-2 inline-block">
        TULJAI  BOUTIQUE'S
        </h2>
        <p className="mt-2 text-[13px] text-start font-extralight tracking-[0.18em] text-amber-200/70">
  परंपरेला आधुनिक स्पर्श
</p>
        {/* Devanagari script integration placeholder */}
        <p className="font-serif text-xl text-amber-100 leading-relaxed tracking-wide">
          तुळजाई माध्यमातून प्रत्येक धाग्यात विणलेली परंपरा... 
        </p>
        
        <p className="text-sm text-gray-300 leading-relaxed font-light">
          Our legacy of handcrafted Nauvari's, an updated legacy of traditional patterns, built precisely to provide customized styling and precision design tailored uniquely to you.
        </p>
        
        {/* <button className="mt-4 px-6 py-2 border border-amber-500 text-amber-400 text-xs tracking-widest uppercase hover:bg-amber-600 hover:text-white transition-colors duration-300">
          Learn More
        </button> */}
      </div>
    </div>
  );
};

export default StorySection;